import React from "react";
import DeviceBasedRenderer from "../../../../components/common/DeviceBasedRenderer";
import OrganismDisplayViewEduMealPreviewDesktop from "./OrganismDisplayViewEduMealPreviewDesktop";
import OrganismDisplayViewEduMealPreviewMobile from "./OrganismDisplayViewEduMealPreviewMobile";

const OrganismDisplayViewEduMealPreview = (props) => {
  console.log(
    "🎯 기기별 밀 미리보기 라우터 - OrganismDisplayViewEduMealPreview"
  );

  return (
    <DeviceBasedRenderer
      DesktopComponent={OrganismDisplayViewEduMealPreviewDesktop}
      MobileComponent={OrganismDisplayViewEduMealPreviewMobile}
      AndroidComponent={OrganismDisplayViewEduMealPreviewMobile} // 안드로이드도 모바일 컴포넌트 사용
      IOSComponent={OrganismDisplayViewEduMealPreviewMobile} // iOS도 모바일 컴포넌트 사용
      {...props} // 모든 props를 하위 컴포넌트에 전달
    />
  );
};

export default OrganismDisplayViewEduMealPreview;
